import React, { useState } from 'react';
import './styles.css';
import Sidebar from './components/Sidebar';
import { useNotif, NotifContainer } from './components/UI';
import Dashboard from './pages/Dashboard';
import Recepcion from './pages/Recepcion';
import { Lotes, Pedidos, RecepcionCocina, Historial, Maestro, Stock } from './pages/Pages';
import Pipeline from './pages/Pipeline';

export default function App() {
  const [page, setPage] = useState('dashboard');
  const { notifs, show } = useNotif();

  const pages = {
    dashboard: <Dashboard onNav={setPage} />,
    recepcion: <Recepcion showNotif={show} />,
    lotes: <Lotes />,
    pedidos: <Pedidos showNotif={show} />,
    'recepcion-cocina': <RecepcionCocina showNotif={show} />,
    historial: <Historial />,
    maestro: <Maestro showNotif={show} />,
    stock: <Stock />,
    pipeline: <Pipeline />,
  };

  return (
    <div className="app-shell">
      <Sidebar current={page} onNav={setPage} />
      <main className="main-content">
        {pages[page]}
      </main>
      <NotifContainer notifs={notifs} />
    </div>
  );
}
